import { useState, useEffect } from 'react';
import '../styles/hero-slider.css';

interface Slide {
  id: number;
  title: string;
  description: string;
  bgImage: string;
  bgGradient: string;
}

const slides: Slide[] = [
  {
    id: 1,
    title: 'Trường Đại học Y Dược Cần Thơ',
    description: 'Đào tạo nguồn nhân lực y tế chất lượng cao',
    bgImage: '/images/ctump/1.jpg',
    bgGradient: 'linear-gradient(135deg, rgba(26, 71, 157, 0.55) 0%, rgba(192, 57, 43, 0.55) 100%)'
  },
  {
    id: 2,
    title: 'Cơ sở vật chất hiện đại',
    description: '31 hecta, 8 tòa nhà, các trung tâm thí nghiệm tiên tiến',
    bgImage: '/images/ctump/2.jpg',
    bgGradient: 'linear-gradient(135deg, rgba(192, 57, 43, 0.55) 0%, rgba(26, 71, 157, 0.55) 100%)'
  },
  {
    id: 3,
    title: '32,000 sinh viên tốt nghiệp',
    description: '97% có việc làm sau 1 năm - Chất lượng được chứng minh',
    bgImage: '/images/ctump/3.jpg',
    bgGradient: 'linear-gradient(135deg, rgba(26, 71, 157, 0.55) 0%, rgba(192, 57, 43, 0.55) 100%)'
  },
  {
    id: 4,
    title: 'Nghiên cứu khoa học tiên tiến',
    description: 'Đóng góp cho sự phát triển y tế và khoa học Việt Nam',
    bgImage: '/images/ctump/4.jpg',
    bgGradient: 'linear-gradient(135deg, rgba(192, 57, 43, 0.55) 0%, rgba(26, 71, 157, 0.55) 100%)'
  }
];

export default function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  useEffect(() => {
    if (!autoPlay) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [autoPlay]);

  const handleNext = () => {
    setAutoPlay(false);
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const handlePrev = () => {
    setAutoPlay(false);
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const handleDotClick = (index: number) => {
    setAutoPlay(false);
    setCurrentSlide(index);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  return (
    <div className="hero-slider">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          style={{
            backgroundImage: `${slide.bgGradient}, url('${slide.bgImage}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="slide-overlay"></div>
          <div className="hero-content">
            <div className="hero-text-box">
              <h1 className="hero-title">{slide.title}</h1>
              <p className="hero-description">{slide.description}</p>
              <button className="btn btn-primary hero-btn">Tìm hiểu thêm</button>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      <button className="slider-nav slider-prev" onClick={handlePrev} aria-label="Previous slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <button className="slider-nav slider-next" onClick={handleNext} aria-label="Next slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      {/* Dots Navigation */}
      <div className="slider-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
          ></button>
        ))}
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <span className="scroll-text">Cuộn xuống</span>
        <div className="scroll-icon">
          <span></span>
        </div>
      </div>
    </div>
  );
}